import React, { Component } from "react";
import { isDesktopOrLaptop } from "../generico/utils/TamanhoPantalla";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faTrashCan} from "@fortawesome/free-solid-svg-icons";

export default class TecladoPin extends Component {

  constructor(props) {
    super(props);
    this.limpiarPin = this.limpiarPin.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.borrarCaracterPin = this.borrarCaracterPin.bind(this);
    this.state = {
      numeros: this.cargar(),
      pin: "",
      loading: false,
      showBox: false,
      showBoxConf: false,
      message: "",
      pinLength: this.props.pinLength ? this.props.pinLength : 6,
    };
  }

  limpiarPin() {
    var vacio = "";
    this.props.pinValue(vacio);
    this.setState({
      pin: vacio,
    });
  }

  borrarCaracterPin() {

    var caracteres = this.state.pin;
    caracteres = caracteres.substring(0, caracteres.length - 1)
    //console.log("caracteres "+caracteres)
    this.props.pinValue(caracteres);
    this.setState({
      pin: caracteres,
    });
  }

  handleClick = (value) => () => {
    if (this.state.pin.length >= this.state.pinLength) {
      return;
    }

    var pinNew = this.state.pin + this.state.numeros[value];

    this.props.pinValue(pinNew);
    this.setState({
      pin: pinNew,
      showBox: isDesktopOrLaptop(), //true,
     // numeros: this.cargar(),
    });
  };

  handleBoxToggle = () => {
    if (isDesktopOrLaptop()) {
      this.setState({ showBox: !this.state.showBox });
    }
  }
  handleBoxOut = () => {
    if (isDesktopOrLaptop()) {
      this.setState({ showBox: !this.state.showBox });
    }
  }

  cargar() {
    var _valores = [];
    for (var i = 0; i < 10; i++) {
      _valores[i] = i;
    }
    for (let i = _valores.length - 1; i > 0; i--) {
      let indiceAleatorio = Math.floor(Math.random() * (i + 1));
      let temporal = _valores[i];
      _valores[i] = _valores[indiceAleatorio];
      _valores[indiceAleatorio] = temporal;
    }
    return _valores;
  }

  render() {
    return (
      <div
        className="row justify-content-md-center"
        style={{ maxWidth: "250px" }}
      >
        <div className="col-12">
          <div className="form-group">
            <label className="input-label-bold">{this.props.label}</label>
            <input
              type="password"
              className="input-box form-control"
              maxLength={this.state.pinLength}
              id="valor"
              value={this.state.pin}
              onChange={(evt) => {
                //console.log(evt.target.value);
                //console.log(this.state.pin);
              }}
              disabled
            />
          </div>
        </div>
        <div className="col-12">
          <div
            className="container"
          >
            <div className="row rowBotones">
              <div className="btn-teclado-contenedor">
                <a
                  className="btn btn-default btn-teclado"
                  onClick={this.handleClick("0")}
                 
                  onMouseOut={this.handleBoxOut}
                >
                  {this.state.numeros[0]}
                </a>
              </div>
              <div className="btn-teclado-contenedor">
                <a
                  className="btn btn-default btn-teclado"
                  onClick={this.handleClick("1")}
                  
                  onMouseOut={this.handleBoxOut}
                >
                  {this.state.numeros[1]}
                </a>
              </div>
              <div className="btn-teclado-contenedor">
                <a
                  className="btn btn-default btn-teclado"
                  onClick={this.handleClick("2")}
                 
                  onMouseOut={this.handleBoxOut}
                >
                  {this.state.numeros[2]}
                </a>
              </div>
              <div className="btn-teclado-contenedor">
                <a
                  className="btn btn-default btn-teclado"
                  onClick={this.handleClick("3")}
                 
                  onMouseOut={this.handleBoxOut}
                >
                  {this.state.numeros[3]}
                </a>
              </div>
            </div>
            <div className="row rowBotones">
              <div className="btn-teclado-contenedor">
                <a
                  className="btn btn-default btn-teclado"
                  onClick={this.handleClick("4")}
                  
                  onMouseOut={this.handleBoxOut}
                >
                  {this.state.numeros[4]}
                </a>
              </div>
              <div className="btn-teclado-contenedor">
                <a
                  className="btn btn-default btn-teclado"
                  onClick={this.handleClick("5")}
               
                  onMouseOut={this.handleBoxOut}
                >
                  { this.state.numeros[5]}
                </a>
              </div>
              <div className="btn-teclado-contenedor">
                <a
                  className="btn btn-default btn-teclado"
                  onClick={this.handleClick("6")}
             
                  onMouseOut={this.handleBoxOut}
                >
                  {this.state.numeros[6]}
                </a>
              </div>
              <div className="btn-teclado-contenedor">
                <a
                  className="btn btn-default btn-teclado"
                  onClick={this.handleClick("7")}
              
                  onMouseOut={this.handleBoxOut}
                >
                  {this.state.numeros[7]}
                </a>
              </div>
            </div>
            <div className="row rowBotones">
              <div className="btn-teclado-contenedor">
                <a
                  className="btn btn-default btn-teclado"
                  onClick={this.handleClick("8")}
              
                  onMouseOut={this.handleBoxOut}
                >
                  {this.state.numeros[8]}
                </a>
              </div>
              <div className="btn-teclado-contenedor">
                <a
                  className="btn btn-default btn-teclado"
                  onClick={this.handleClick("9")}
                
               
                >
                  {this.state.numeros[9]}
                </a>
              </div>
              <div className="btn-teclado-contenedor">
                <a
                  className="btn btn-default btn-teclado"
                  onClick={this.borrarCaracterPin}
                  onMouseOver={this.handleBoxToggle} onMouseOut={this.handleBoxOut}
                >
                  <i className="fas fa-chevron-left" />
                </a>
              </div>
              <div className="btn-teclado-contenedor">
                <a
                  className="btn btn-default btn-teclado"
                  onClick={this.limpiarPin}
                  onMouseOut={this.handleBoxOut}
                >
                 <FontAwesomeIcon icon={faTrashCan} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
